var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ps-app-mode-space"},[_c('app-controls',{class:{
      'ps-is-active': _vm.routerMatches('ROUTE_CONTROLS')
    },on:{"ps-dom":_vm.setActiveDom}}),_c('card-list',{class:{ 'ps-is-active': _vm.routerMatches('ROUTE_LIST') }}),_c('card-details',{class:{
      'ps-is-active': _vm.routerMatches('ROUTE_CARD'),
      'ps-is-active ps-is-peek': _vm.routerMatches('ROUTE_CARD_PEEK')
    }}),_c('app-me',{class:{ 'ps-is-active': _vm.routerMatches('ROUTE_ME') }}),_c('app-help',{class:{ 'ps-is-active': _vm.routerMatches('ROUTE_HELP') }}),_c('app-dots')],1)}
var staticRenderFns = []

export { render, staticRenderFns }